module.exports = __webpack_public_path__ + "banquet/components/images/button_menu_close.b516325fcc5ec1c1af018bc48fa151d8.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/button_menu_close.png
// module id = 147
// module chunks = 0 1